<template>
  <shared-product-edit :product="product" :images="images">
    <panel title="Preço por canal de venda" slot="before-price" v-if="salesChannel.length">
      <panel class="blue-panel" :title="saleChannel.label" v-for="saleChannel in salesChannel" :useAcordion="true" :blockToggle="!saleChannel.active">
        <label class="form-switch" slot="header-right">
          <input type="checkbox" v-model="saleChannel.active">
          <span class="form-switch__indicator"></span>
        </label>

        <panel>
          <div class="l-row">
            <div class="l-col-12@md">
              <product-price :input="saleChannel.price" :module="product.source" :sku="product.sku"/>
            </div>
          </div>
        </panel>
      </panel>
    </panel>
  </shared-product-edit>
</template>

<script>
  import api from '@/api'
  import { mapGetters } from 'vuex'
  import SharedProductEdit from '@/components/marketplace/shared/ProductEdit'
  import Panel from '@/components/template/Panel'
  import ProductPrice from '@/components/shared/ProductPrice'

  export default {
    data: () => ({
      salesChannel: []
    }),
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      this.salesChannel = (await api.skyhub.getSalesChannel()).map(saleChannel => {
        const productSaleChannel = this.product.salesChannel.find(channel => channel.identifier === saleChannel.code)

        const price = productSaleChannel !== undefined ? productSaleChannel.price : {
          type: this.toModuleDefinition.module.configs.product.price.type,
          cost: 0,
          auxiliary: 0,
          previous: this.product.price.previous,
          current: this.product.price.current
        }

        return {
          ...saleChannel,
          identifier: saleChannel.code,
          active: productSaleChannel !== undefined,
          price
        }
      })
    },
    methods: {
      formatProduct () {
        return {
          ...this.product,
          salesChannel: this.salesChannel.filter(saleChannel => saleChannel.active)
        }
      }
    },
    computed: {
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      images () {
        return this.product.images
      },
      toModuleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType('marketplace', 'skyhub')
      }
    },
    components: {
      SharedProductEdit,
      Panel,
      ProductPrice
    }
  }
</script>

<style lang="sass" scoped>
  .margin
    margin-top: 10px
</style>



// WEBPACK FOOTER //
// ProductEdit.vue?74f2bf11